import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ProviderClient } from '@classes/config/provider-client';
import { Provider } from '@classes/provider';
import { environment } from '@environments/environment';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class ProviderService {
	private readonly providersSubject = new BehaviorSubject<Provider[]>([]);
    private readonly editedProviderSubject = new BehaviorSubject<ProviderClient>(null);
    private readonly newProviderClientSubject = new BehaviorSubject<ProviderClient>(null);

	private readonly baseUrl = environment.apiUrl + 'provider';

    private readonly http = inject(HttpClient);

	constructor() {}

    get editedProvider$(): Observable<ProviderClient> {
        return this.editedProviderSubject.asObservable();
    }

    get newProviderClient$(): Observable<ProviderClient> {
        return this.newProviderClientSubject.asObservable();
    }

    set editedProvider(pC: ProviderClient) {
        this.editedProviderSubject.next(pC);
    }

    set newProviderClient(pC: ProviderClient) {
        this.newProviderClientSubject.next(pC);
    }

	get(): Observable<Provider[]> {
		if (this.providersSubject.getValue()?.length) {
			return this.providersSubject.asObservable();
		} else {
			return this.http.get<Provider[]>(this.baseUrl)
                .pipe(
			    	map(
                        (result: Provider[]) => {
                            const providers: Provider[] = result.map(p => Provider.fromObject(p));
                            this.providersSubject.next(providers)
                            return providers;
                        }
                    )
			    );
		}
	}

    getProviderClient(): Observable<ProviderClient[]> {
        return this.http.get<ProviderClient[]>(`${this.baseUrl}/client`);
    }

    postProviderClient(newProviderClient: ProviderClient): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}/client`, newProviderClient);
    }

    updateProviderClient(newProviderClient: ProviderClient): Observable<any> {
        return this.http.put<any>(`${this.baseUrl}/client`, newProviderClient);
    }

    deleteProviderClient(id: number): Observable<void> {
        const params = new HttpParams()
            .append('id', `${id}`);

        return this.http.delete<void>(`${this.baseUrl}/client`, {params})
    }

    testSourceConnection(providerClient: ProviderClient): Observable<boolean> {
        return this.http.post<boolean>(`${this.baseUrl}/test-sftp`, providerClient);
    }

    // getCronExpression(): Observable<string[]> {
    //     return this.http.get<string[]>(`${this.baseUrl}/client/cron`);
    // }

}
